/**
 * TaskCardSkeleton — single source of truth for the task card loading placeholder.
 * Used by PageSkeleton (route-level Suspense) and TaskCardEmpty (data loading),
 * so the user never sees two different skeletons on the same page.
 */
const TaskCardSkeleton = () => (
  <div className="glass-card rounded-3xl p-6 md:p-8 space-y-4">
    {/* Filter row — pills */}
    <div className="flex items-center gap-2 flex-wrap">
      <div className="h-7 w-16 rounded-full bg-muted animate-pulse" />
      <div className="h-6 w-24 rounded-full bg-muted animate-pulse" style={{ animationDelay: '0.05s' }} />
      <div className="h-6 w-16 rounded-full bg-muted animate-pulse" style={{ animationDelay: '0.1s' }} />
      <div className="h-6 w-20 rounded-full bg-muted animate-pulse" style={{ animationDelay: '0.15s' }} />
    </div>

    <hr className="border-border" />

    {/* Task title */}
    <div className="h-6 w-3/5 rounded-lg bg-muted animate-pulse" style={{ animationDelay: '0.1s' }} />

    {/* Task badges */}
    <div className="flex items-center gap-2">
      <div className="h-5 w-20 rounded-full bg-muted animate-pulse" style={{ animationDelay: '0.15s' }} />
      <div className="h-5 w-14 rounded-full bg-muted animate-pulse" style={{ animationDelay: '0.2s' }} />
    </div>

    <hr className="border-border" />

    {/* Question text lines */}
    <div className="space-y-2">
      <div className="h-4 w-full rounded bg-muted animate-pulse" style={{ animationDelay: '0.15s' }} />
      <div className="h-4 w-5/6 rounded bg-muted animate-pulse" style={{ animationDelay: '0.2s' }} />
      <div className="h-4 w-3/5 rounded bg-muted animate-pulse" style={{ animationDelay: '0.25s' }} />
    </div>

    {/* Image placeholder */}
    <div className="h-40 w-full rounded-xl bg-muted animate-pulse flex items-center justify-center" style={{ animationDelay: '0.2s' }}>
      <svg className="w-10 h-10 text-muted-foreground/20" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
        <path strokeLinecap="round" strokeLinejoin="round" d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909M3.75 21h16.5A2.25 2.25 0 0 0 22.5 18.75V5.25A2.25 2.25 0 0 0 20.25 3H3.75A2.25 2.25 0 0 0 1.5 5.25v13.5A2.25 2.25 0 0 0 3.75 21Z" />
      </svg>
    </div>

    {/* ABCD answer buttons */}
    <div className="space-y-2">
      {['A', 'B', 'C', 'D'].map((letter, i) => (
        <div
          key={letter}
          className="glass-card rounded-xl p-3 md:p-4 flex items-center gap-3 animate-pulse"
          style={{ animationDelay: `${0.25 + i * 0.05}s` }}
        >
          <span className="text-sm font-bold text-muted-foreground/30 w-6 shrink-0">{letter}.</span>
          <div className="h-4 rounded bg-muted" style={{ width: `${70 - i * 8}%` }} />
        </div>
      ))}
    </div>
  </div>
);

export default TaskCardSkeleton;
